import { css } from 'twin.macro';
import { Form } from 'react-bootstrap';
import Linkify from 'react-linkify';

import { marginColor } from './Checkbox';
import { ElementStyled, elementClass } from './styles/ElementStyles';
import { validateFormFileUpload } from './utils/fileUploadValidation';

const AudioCss = css`
    text-align: center;
`;
const AudioFile = ({ data, elementRef, isPreview, error, onChange = () => {} }) => {
    const handleFile = (e) => {
        const audioFile = e.target.files?.[0];
        if (!audioFile) {
            return;
        }

        if (!validateFormFileUpload(audioFile, 'AudioFile')) {
            e.target.value = null;
            return;
        }

        onChange(e);
    };

    return (
        <ElementStyled className={elementClass(data)}>
            {data.value ? (
                <div css={AudioCss}>
                    <div
                        css={css`
                            text-align: left;
                        `}
                    >
                        <h5 className="warpIt">{data.fieldName}</h5>
                        {data.instruction && (
                            <pre className="small text-muted warpIt preStyles">
                                <Linkify
                                    componentDecorator={(decoratedHref, decoratedText, key) => (
                                        <a target="blank" href={decoratedHref} key={key}>
                                            {decoratedText}
                                        </a>
                                    )}
                                >
                                    {data.instruction}
                                </Linkify>
                            </pre>
                        )}
                    </div>
                    <audio id="myAudio" controls>
                        <source src={data.value} />
                    </audio>
                </div>
            ) : (
                <Form.Group controlId="formGridFile">
                    <label name={`${!isPreview ? `File-${data._id}` : 'Email'}`}>
                        <h5 className="warpIt">
                            {data.fieldName}
                            <span css={marginColor}>
                                {(data.hasOwnProperty('required') ? data.required : true) && '*'}
                            </span>
                        </h5>

                        {data.instruction && <span className="small text-muted warpIt">{data.instruction}</span>}
                    </label>
                    <br />
                    <input
                        accept="audio/*"
                        type="file"
                        name={`${!isPreview ? `AudioFile-${data._id}` : 'AudioFile'}`}
                        disabled={isPreview || data.value}
                        onChange={handleFile}
                        ref={
                            elementRef &&
                            elementRef({
                                required: data.hasOwnProperty('required') ? data.required : true,
                            })
                        }
                    />
                    <Form.Text className="text-danger">
                        {error && error.type === 'required' && 'This field is required'}
                    </Form.Text>
                </Form.Group>
            )}
        </ElementStyled>
    );
};

export default AudioFile;
